"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderProvider = exports.useLoaderContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var loaderContext_1 = require("./loaderContext");
Object.defineProperty(exports, "useLoaderContext", { enumerable: true, get: function () { return loaderContext_1.useLoaderContext; } });
Object.defineProperty(exports, "LoaderProvider", { enumerable: true, get: function () { return loaderContext_1.LoaderProvider; } });
var DualRing_1 = __importDefault(require("./dual-ring/DualRing"));
var Hourglass_1 = __importDefault(require("./hourglass/Hourglass"));
var Spinner_1 = __importDefault(require("./spinner/Spinner"));
var DotSpinner_1 = __importDefault(require("./dot-spinner/DotSpinner"));
var Pulse_1 = __importDefault(require("./pulse/Pulse"));
var Ellipsis_1 = __importDefault(require("./ellipsis/Ellipsis"));
var Ring_1 = __importDefault(require("./ring/Ring"));
var Roller_1 = __importDefault(require("./roller/Roller"));
var Grid_1 = __importDefault(require("./grid/Grid"));
var Ripple_1 = __importDefault(require("./ripple/Ripple"));
var Circle_1 = __importDefault(require("./circle/Circle"));
var components = {
    dualring: DualRing_1.default,
    hourglass: Hourglass_1.default,
    spinner: Spinner_1.default,
    dotspinner: DotSpinner_1.default,
    pulse: Pulse_1.default,
    ellipsis: Ellipsis_1.default,
    ring: Ring_1.default,
    roller: Roller_1.default,
    grid: Grid_1.default,
    ripple: Ripple_1.default,
    circle: Circle_1.default,
};
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   display: flex;\n   justify-content: center;\n"], ["\n   display: flex;\n   justify-content: center;\n"])));
var Loader = function (_a) {
    var type = _a.type, color = _a.color, altColor = _a.altColor, size = _a.size, message = _a.message, className = _a.className;
    var context = loaderContext_1.useLoaderContext();
    var selectedType = type || (context === null || context === void 0 ? void 0 : context.type) || 'spinner';
    var SelectedLoader = components[selectedType];
    var primaryColor = color || (context === null || context === void 0 ? void 0 : context.color) || 'currentColor';
    var secondaryColor = altColor || (context === null || context === void 0 ? void 0 : context.altColor) || primaryColor;
    var selectedSize = size || (context === null || context === void 0 ? void 0 : context.size) || 100;
    var classes = (className ? className : '') + " " + ((context === null || context === void 0 ? void 0 : context.className) ? context.className : '') + " ";
    var cssValues = {
        '--rts-color': primaryColor,
        '--rts-secondary-color': secondaryColor,
    };
    var messageText = message ? message : 'Content is loading.';
    return (jsx_runtime_1.jsx(Wrapper, __assign({ className: classes }, { children: jsx_runtime_1.jsx("div", __assign({ style: cssValues, role: "alert", "aria-live": "assertive" }, { children: jsx_runtime_1.jsx(SelectedLoader, { ratio: selectedSize, message: messageText }, void 0) }), void 0) }), void 0));
};
exports.default = Loader;
var templateObject_1;
